import { render, staticRenderFns } from "./hotBox.vue?vue&type=template&id=30100dc6&scoped=true&"
import script from "./hotBox.vue?vue&type=script&lang=js&"
export * from "./hotBox.vue?vue&type=script&lang=js&"
import style0 from "./hotBox.vue?vue&type=style&index=0&id=30100dc6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30100dc6",
  null
  
)

export default component.exports